<template lang="pug">
  .navbar.navbar-dark(
    :style="{opacity:this.opacity}"
    ref="navbarTop"
    )
    .navbar-wrapper
      .left
        .navbar-logo
          img(src="@/assets/icons/17life_logo.svg")
          a(@click="navigateToHome",href="javascript:void(0);")
      .center
        .navbar-search-bar.dark
          img.search-default(
            src="@/assets/icons/ic_search_sm.svg"
            )
          input(
            type="text",
            max-length="20",
            placeholder="輸入關鍵字進行搜尋"
          )
      .right
        //- .navbar-search.ic-sm(@click="searchClick")
        //-   img(src="@/assets/icons/ic_search.svg")
        //- .navbar-favorite.ic-sm(@click="favoriteListClick")
        //-   img(src="@/assets/icons/ic_favorite.svg")
        //- .navbar-member.ic-sm(@click="memberClick")
        //-   img(class="head",:src="memberPic",v-if="memberAuthentication")
        //-   img(src="@/assets/icons/ic_member.svg",v-else)
        .navbar-messege.ic-sm
          img(src="@/assets/icons/ic_events_sm_dark.svg")
</template>

<script>
export default {
  name: 'navbar',
  components:{
  },
  props:{
    opacity:{
      type: Number,
      required: false,
    },
  },
  methods:{
    navigateToHome(){
      this.$router.push({name:'home'})
    }
  },
}
</script>

<style lang="scss">
  
</style>
